import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ProductCountResolvedChange =
  ProjectChangeMap[ProjectChangeType.ProductElementCountResolved];

/**
 * Build a partial element change for ProductElementCountResolved.
 *
 * @param element - Current element state
 * @param change - Resolved count payload
 * @returns Partial<OneOfElements> or undefined
 */
export const productElementCountResolvedToChange = (
  element: OneOfElements,
  change: ProductCountResolvedChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.productElement(element)) return undefined;
  if (!element.count) return undefined;
  if (element.count.resolved === change.value) return undefined;

  return {
    count: { ...element.count, resolved: change.value },
  };
};
